import { IReportForm, IReportParameters, IReportsState, IRevenueState, IUserReport } from "../model"

export function getDefaultReportsState(): IReportsState {
  return {
    createForm: getReportFormState(true),
    editForm: getReportFormState(false),
    isListLoading: false,
    hasListLoadingError: false,
    userReports: null,
    revenue: getDefaultRevenueState()
  }
}

export const getDefaultReportParameters = (report?: IUserReport): IReportParameters => ({
  filters: report && report.filters ? report.filters : {},
  groupBys: report ? report.groupBys : [],
  sortBys: report && report.sortBys ? report.sortBys : [],
  name: report && report.name ? report.name : "",
  description: report && report.description ? report.description : ""
})

export const getReportFormState = (isCreation: boolean, report?: IUserReport): IReportForm => ({
  parameters: getDefaultReportParameters(report),
  results: null,
  isResultLoading: report ? true : false,
  hasResultLoadingError: false,
  isParametersPanelOpened: true,
  report: report || null,
  isCreation,
  isUpdating: false,
  updateFormError: ""
})

const getDefaultRevenueState = (): IRevenueState => ({
  chartDataSets: [],
  total: null,
  isLoading: false,
  hasLoadingError: false
})
